"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SUPPORT_TICKET_DESCRIPTION_LENGTH = exports.MAX_SUPPORT_TICKET_TITLE_LENGTH = void 0;
exports.MAX_SUPPORT_TICKET_TITLE_LENGTH = 200;
exports.MAX_SUPPORT_TICKET_DESCRIPTION_LENGTH = 5000;
